<script lang="ts" setup>
import ErrorNotFound from '@/components/Error/NotFound.vue'
import ErrorSomethingWrong from '@/components/Error/SomethingWrong.vue'

import type { NuxtError } from '#app'

interface Props {
  error: NuxtError
}

const props = defineProps<Props>()

const errorComponent = computed(() =>
  +props.error?.statusCode === 404
    ? markRaw(ErrorNotFound)
    : markRaw(ErrorSomethingWrong),
)
</script>

<template>
  <NuxtLayout>
    <component :is="errorComponent" />
  </NuxtLayout>
</template>
